import { DEVEXTREME_LICENSE_KEY } from "@bds/devextreme-license";
export const DevExtremeLicenseProvider = {
    provide: DEVEXTREME_LICENSE_KEY,
    useValue: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImEzNDg5ZWM0LTVmZTgtNDgwOS1hZWYxLWMyYzkwNjNkNWU3YiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.tUBcNULwto3FOE3yu5BVnewoINNCyZP1uSwIBX/kiqE77f9C4KoQwSCI0G/eyH33YujzLQWf4Tz7iyNZZuCX1tiB/E/wg6DHJm4IkqSWwipnQo0No3rQYDNxNKT6sxpfPd4+fg=='
};
